import type { EventGuest } from "@anggunpraya-templates/types";
import { useEventGuestLoader as useBaseEventGuestLoader } from "@anggunpraya-templates/base/app/composables/use-event-guest-loader";
import { EVENT_GUEST } from "~/data";

export function useEventGuestLoader() {
  return useBaseEventGuestLoader({
    previewGuest: EVENT_GUEST as EventGuest,
  });
}
